import React from 'react'

import { Section, SectionHeading } from '../../../components/ui'
import { FAQ_GROUPS } from './faqs'

import './questions.css'

// THE QUESTIONS. Three bands, each with its own H2, and every question an
// accordion row inside them.
//
// WHY <details> AND NOT A REACT ACCORDION. It is already this site's
// disclosure vocabulary and it is the cheapest correct answer in every
// direction. sections/areas-cta folds its nine area groups into <details>,
// and /services folds each wash's "What's included" list the same way, with
// the chevron drawn as two borders on a rotated 7px box rather than an icon
// import. A <summary> is a button to the accessibility tree already, with
// aria-expanded maintained by the browser, so there is no state, no
// useEffect, no keyboard handler and no ARIA of our own to get wrong. Every
// answer is in the markup of a shut row, so a crawler reads all seventeen and
// a reader with no JavaScript can still open them. The FAQPage JSON-LD
// (SeoHelper#seo_faq, rendered only on this path) therefore matches visible
// page text, which is what Google asks of it.
//
// SHUT AT EVERY WIDTH, unlike the areas index. The areas groups open at
// 960px because a laptop has three columns of room and 52 links to show; a
// seventeen-question FAQ has the opposite problem, which is that the thing a
// visitor wants is one row out of seventeen. Shut, the three bands are a
// menu of the whole page in about two screens. That also means this section
// needs no matchMedia and no JavaScript at all.
//
// ONE H2 PER SECTION (DESIGN.md §7), so the three topic groups are three
// <Section>s rather than three H3s inside one. Levels run H1 (the intro
// section) then H2 per band then H3 per question, with nothing skipped. The
// H3 lives inside the <summary>, which is allowed exactly one heading
// element, so the question is both the heading and the tap target rather
// than a div pretending to be one.
//
// BANDS. paper, stone, paper, which with the paper intro above and the stone
// "ask us" band below alternates all the way down the page. Changing one
// group's background means changing its neighbours (DESIGN.md §6).
//
// The copy, and the sources behind every answer, are in ./faqs.js. Read the
// header of that file before changing a word of it: three of these answers
// are worded the way they are because the codebase contradicts itself about
// them and this page is not the place to pick a side.

const QuestionRow = ({ item }) => (
  <details className="faq-item">
    <summary className="faq-summary">
      <h3 className="gwmc-h3 faq-q">{item.q}</h3>
    </summary>
    <div className="faq-a">{item.a}</div>
  </details>
)

export const Questions = () => (
  <>
    {FAQ_GROUPS.map(group => (
      <Section key={group.id} id={group.id} background={group.band} className="faq-band">
        <SectionHeading intro={group.intro}>{group.title}</SectionHeading>

        <div className="faq-list">
          {group.items.map(item => (
            <QuestionRow key={item.q} item={item} />
          ))}
        </div>
      </Section>
    ))}
  </>
)
